<div class="sign-in">
  <div id="sign-in__header" class="sign-in__header">
    <span>
      <img
        src="assets/RA LOGO-01.svg"
        class="sign-in__header__logo"
        routerLink=""
      />
    </span>
  </div>
  <div
    class="sign-in__content"
    [ngClass]="{
      'sign-in__content--forgot': displayType === 'forgot',
      'sign-in__content--register': displayType === 'register'
    }"
  >
    <ng-container
      *ngIf="displayType !== 'registerSuccess'; else registerSuccessScreen"
    >
      <div class="sign-in__content__header">
        <h2 class="sign-in__content__header--head">
          {{
            displayType === "register"
              ? "Register"
              : displayType === "forgot"
              ? "Forgot Password"
              : displayType === "reset"
              ? "Reset Password"
              : "Sign in"
          }}
        </h2>
        <p
          class="sign-in__content__header--sub"
          *ngIf="verifySuccess && displayType === 'signin'"
        >
          Thank you for verifing the account. Please login to complete the
          registration
        </p>
        <p
          class="sign-in__content__header--sub"
          *ngIf="resetPasswordSuccess && displayType === 'signin'"
        >
          Successfully reset password! Please login with new password
        </p>
      </div>
      <form
        class="sign-in__content__form"
        [formGroup]="signInForm"
        (ngSubmit)="signIn()"
        *ngIf="displayType === 'signin'"
      >
        <div class="d-grid gap-1">
          <span class="fs-6">Email</span>
          <input
            type="email"
            formControlName="email"
            class="sign-in__content__form__input"
            [ngClass]="{
              'error-border':
                (error || signInForm.controls['email'].touched) &&
                signInForm.controls['email'].invalid
            }"
          />
        </div>
        <div class="d-grid gap-1">
          <span class="fs-6">Password</span>
          <div class="sign-in__content__form__password">
            <input
              [type]="displayPassword ? 'text' : 'password'"
              formControlName="password"
              class="sign-in__content__form__input"
              [ngClass]="{
                'error-border':
                  (error || signInForm.controls['password'].touched) &&
                  signInForm.controls['password'].invalid
              }"
              [maxlength]="32"
            />
            <mat-icon
              (click)="displayPassword = !displayPassword"
              class="sign-in__content__form__password__icon"
              >{{ displayPassword ? "visibility_off" : "visibility" }}</mat-icon
            >
          </div>
        </div>
        <span
          class="justify-self-end sign-in__content__form__link"
          (click)="forgotEmailInit(); displayType = 'forgot'"
          >Fogot Password?</span
        >
        <button type="submit" class="button button__green">Sign In</button>
        <div>
          New user?
          <span
            class="sign-in__content__form__link"
            (click)="registerFormInit(); displayType = 'register'"
            >Register here</span
          >
        </div>
      </form>
      <form
        class="sign-in__content__form"
        [formGroup]="registerForm"
        (ngSubmit)="register()"
        *ngIf="displayType === 'register'"
      >
        <div class="d-grid gap-1">
          <span class="fs-6">First Name</span>
          <input
            type="text"
            formControlName="firstName"
            class="sign-in__content__form__input"
            [ngClass]="{
              'error-border':
                (error || registerForm.controls['firstName'].touched) &&
                registerForm.controls['firstName'].invalid
            }"
          />
        </div>
        <div class="d-grid gap-1">
          <span class="fs-6">Last Name</span>
          <input
            type="text"
            formControlName="lastName"
            class="sign-in__content__form__input"
            [ngClass]="{
              'error-border':
                (error || registerForm.controls['lastName'].touched) &&
                registerForm.controls['lastName'].invalid
            }"
          />
        </div>
        <div class="d-grid gap-1">
          <span class="fs-6">Email</span>
          <input
            type="email"
            formControlName="email"
            class="sign-in__content__form__input"
            [ngClass]="{
              'error-border':
                (error || registerForm.controls['email'].touched) &&
                registerForm.controls['email'].invalid
            }"
          />
        </div>
        <div class="d-grid gap-1">
          <span class="fs-6">Password</span>
          <div class="sign-in__content__form__password">
            <input
              [type]="displayPassword ? 'text' : 'password'"
              formControlName="password"
              class="sign-in__content__form__input"
              [ngClass]="{
                'error-border':
                  (error || registerForm.controls['password'].touched) &&
                  registerForm.controls['password'].invalid
              }"
              [maxlength]="10"
            />
            <mat-icon
              (click)="displayPassword = !displayPassword"
              class="sign-in__content__form__password__icon"
              >{{ displayPassword ? "visibility_off" : "visibility" }}</mat-icon
            >
          </div>
        </div>
        <span
          *ngIf="
            (error || registerForm.controls['password'].touched) &&
            registerForm.controls['password'].invalid
          "
          class="error"
          >Password should contain atleast one uppercase letter, one lowercase
          letter, one number and a special character. Password should be minimum
          8 characters</span
        >
        <div class="d-grid gap-1">
          <span class="fs-6">Confirm Password</span>
          <div class="sign-in__content__form__password">
            <input
              [type]="displayConfirmPassword ? 'text' : 'password'"
              formControlName="confirmPassword"
              class="sign-in__content__form__input"
              [ngClass]="{
                'error-border':
                  (error || registerForm.controls['confirmPassword'].touched) &&
                  registerForm.controls['confirmPassword'].invalid
              }"
              [maxlength]="10"
            />
            <mat-icon
              (click)="displayConfirmPassword = !displayConfirmPassword"
              class="sign-in__content__form__password__icon"
              >{{
                displayConfirmPassword ? "visibility_off" : "visibility"
              }}</mat-icon
            >
          </div>
        </div>
        <!-- <div
          id="recaptcha-container"
          class="g-recaptcha"
          data-sitekey="6LeBkOwrAAAAALki9nGEHtGmFrEcEhaE0fmC9Suo"
        ></div> -->
        <button type="submit" class="button button__green">Register</button>
        <div>
          Already Registered?
          <span
            class="sign-in__content__form__link justify-self-end"
            (click)="signInFormInit(); displayType = 'signin'"
          >
            Sign In
          </span>
        </div>
      </form>
      <form
        class="sign-in__content__form"
        (ngSubmit)="forgotPassword()"
        *ngIf="displayType === 'forgot'"
      >
        <div class="d-grid gap-1">
          <span class="fs-6">Email</span>
          <input
            type="email"
            [formControl]="forgotEmail"
            class="sign-in__content__form__input"
            [ngClass]="{
              'error-border':
                (error || forgotEmail.touched) && forgotEmail.invalid
            }"
          />
        </div>
        <button type="submit" class="button button__green">
          Send password reset link
        </button>
        <div>
          Go to
          <span
            class="sign-in__content__form__link justify-self-end"
            (click)="signInFormInit(); displayType = 'signin'"
            >Sign In</span
          >
        </div>
      </form>
      <form
        class="sign-in__content__form"
        [formGroup]="resetPasswordForm"
        (ngSubmit)="resetPassword()"
        *ngIf="displayType === 'reset'"
      >
        <div class="d-grid gap-1">
          <span class="fs-6">Password</span>
          <div class="sign-in__content__form__password">
            <input
              [type]="displayPassword ? 'text' : 'password'"
              formControlName="password"
              class="sign-in__content__form__input"
              [ngClass]="{
                'error-border':
                  (error || resetPasswordForm.controls['password'].touched) &&
                  resetPasswordForm.controls['password'].invalid
              }"
              [maxlength]="10"
            />
            <mat-icon
              (click)="displayPassword = !displayPassword"
              class="sign-in__content__form__password__icon"
              >{{ displayPassword ? "visibility_off" : "visibility" }}</mat-icon
            >
          </div>
        </div>
        <span
          *ngIf="
            (error || resetPasswordForm.controls['password'].touched) &&
            resetPasswordForm.controls['password'].invalid
          "
          class="error"
          >Password should contain atleast one uppercase letter, one lowercase
          letter, one number and a special character. Password should be minimum
          8 characters</span
        >
        <div class="d-grid gap-1">
          <span class="fs-6">Confirm Password</span>
          <div class="sign-in__content__form__password">
            <input
              [type]="displayConfirmPassword ? 'text' : 'password'"
              formControlName="confirmPassword"
              class="sign-in__content__form__input"
              [ngClass]="{
                'error-border':
                  (error ||
                    resetPasswordForm.controls['confirmPassword'].touched) &&
                  resetPasswordForm.controls['confirmPassword'].invalid
              }"
              [maxlength]="32"
            />
            <mat-icon
              (click)="displayConfirmPassword = !displayConfirmPassword"
              class="sign-in__content__form__password__icon"
              >{{
                displayConfirmPassword ? "visibility_off" : "visibility"
              }}</mat-icon
            >
          </div>
        </div>
        <button type="submit" class="button button__green">
          Reset Password
        </button>
        <div>
          Go to
          <span
            class="sign-in__content__form__link justify-self-end"
            (click)="signInFormInit(); displayType = 'signin'"
            >Sign In</span
          >
        </div>
      </form>
    </ng-container>
    <ng-template #registerSuccessScreen>
      <div class="sign-in__register-success">
        Thank you for Sign up. Please check your Inbox/Spam folder to verify
        your account and complete the registration. Redirecting to Register
        page…
      </div>
    </ng-template>
  </div>
</div>

<p-dialog
  [showHeader]="false"
  [resizable]="false"
  class="generic__loader"
  [(visible)]="showLoader"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
>
  <p-progressSpinner> </p-progressSpinner>
</p-dialog>
